import React, { Component } from 'react'

export default class Summary extends Component {
  render() {
    return <div>Summary</div>
  }
}
